// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"5268":"Home","6230":"Catalogmanagement","6650":"Templatemanagement"}[chunkId] + "." + {"5268":"0fa83dcf","6230":"12db826e","6650":"fbd53335"}[chunkId] + ".css";
};